import { useState } from 'react';
import PratusInput from 'components/DesignSystems/New/PratusInput';
import { StylishNewButton } from 'components/DesignSystems/New/StylishNewButton';
import { SharedIcon } from 'components/SharedIcon/SharedIcon';

type EditableTableCellProps = {
  name: string;
  onSave: (value: string) => void;
  onDelete: () => void;
  isDeleteDisabled?: boolean;
  readOnly?: boolean;
  footer?: React.ReactNode;
  placeholder?: string;
};

const EditableTableCell: React.FC<EditableTableCellProps> = ({
  name,
  onSave,
  onDelete,
  isDeleteDisabled = false,
  readOnly = false,
  footer,
  placeholder,
}) => {
  const [editing, setEditing] = useState(false);

  return (
    <div className="d-flex flex-column gap-2">
      <div className="d-flex align-items-start justify-content-between gap-2">
        {editing ? (
          <PratusInput
            defaultValue={name}
            showErrorContainer={false}
            className="flex-grow-1"
            placeholder={placeholder}
            onSave={(value: string) => {
              onSave(value);
              setEditing(false);
            }}
            onCancel={() => setEditing(false)}
          />
        ) : (
          <span className="flex-grow-1">{name}</span>
        )}
        {!readOnly && !editing && (
          <div className="d-flex flex-shrink-0">
            <StylishNewButton
              className="button--link"
              onClick={() => setEditing(true)}
            >
              <SharedIcon iconName="edit" color="light" />
            </StylishNewButton>
            <StylishNewButton
              className="button--link"
              onClick={onDelete}
              disabled={isDeleteDisabled}
            >
              <SharedIcon
                iconName="delete"
                color={isDeleteDisabled ? undefined : 'light'}
              />
            </StylishNewButton>
          </div>
        )}
      </div>
      {footer}
    </div>
  );
};

export default EditableTableCell;
